export default __webpack_public_path__ + "static/media/wallet-2.cc17b8c9.png";